module.exports = __webpack_public_path__ + "img/9791195038350.22554752.jpg";